import { IntegrationServiceId } from './integrations'

/** Meeting providers that require the user to have a connected (live) integration. */
export const INTEGRATIONS_REQUIRING_USER_CONNECTION = new Set([IntegrationServiceId.ZOOM])

/** Per-provider map of account/parent IDs exempt from integration requirements. */
export const INTEGRATION_EXEMPT_ACCOUNT_IDS: Partial<Record<IntegrationServiceId, Set<string>>> = {
  [IntegrationServiceId.ZOOM]: new Set([
    '4me3xelt41bgk62p', // MassMutual Parent
  ]),
}

export const ZOOM_OBF_DEADLINE_LABEL = 'March 2'

export interface IntegrationRequirementResult {
  satisfied: boolean
  accountAllowed: boolean
}
